<div class="client-page-content">

  <div class="content-header">
    <h2 *ngIf="!store.multipleBookings">{{ 'CLIENT.clientServices.title' | translate }}</h2>
    <h2 *ngIf="store.multipleBookings">{{ 'CLIENT.clientServices.title_multi' | translate }}</h2>
  </div>

  <ul class="options" *ngIf="!loading">
    <li *ngFor="let service of services" class="service-line" [class.collapsed-service]="isServiceCollapsed(service.categoryId)">
      <div class="row align-items-center" *ngIf="service.category">
        <div class="col d-flex-center-between" (click)="toggleCategory(service)">
          <span class="option-category">{{service?.name}}</span>
          <i *ngIf="!service.collapsed" class="material-icons icon clickable align-self-end align-self-center pt-3">expand_less</i>
          <i *ngIf="service.collapsed" class="material-icons icon clickable align-self-end align-self-center pt-3">expand_more</i>
        </div>
      </div>
      <div class="d-flex justify-content-between align-items-start" (click)="selectService(service)" *ngIf="!service.category">
        <div class="d-flex align-items-center">
          <div *ngIf="store.multipleBookings" data-nosnippet class="pr-2 align-items-center unselectable">
            <span *ngIf="service.checked"><i class="material-icons icon selected">check_circle</i></span>
            <span *ngIf="!service.checked"><i class="material-icons icon">check_circle_outline</i></span>
          </div>
          <div class="pr-2">
            <a class="option">{{service?.name}}</a>
            <p class="text-small text-secondary mb-0" *ngIf="service.description">{{service?.description}}</p>
          </div>
        </div>

        <div class="text-right">
          <span class="text-secondary text-bold" *ngIf="service?.price > 0">{{service?.price | currency:service?.currency:'symbol-narrow':'1.0-2'}}</span>
        </div>
      </div>
    </li>
  </ul>

  <div class="mt-3 services-button-wrapper" *ngIf="store.multipleBookings && !loading" [class.disabled]="selectedServices.length === 0" [class.activated]="selectedServices.length > 0">
    <app-submit-btn [inputClasses]="'btn-black btn-lg w-100'" (click)="saveMultiSelection()" [disabled]="selectedServices.length === 0" inputClasses="w-100 mt-4" btnCopy="{{ 'GENERAL.continue' | translate }}"></app-submit-btn>
  </div>

  <app-loader-list-placeholder *ngIf="loading"></app-loader-list-placeholder>
</div>
